import Vue from 'vue';
import fvRender from "./fvRender"
import fvRenderContract from "./fvRenderContract"
import fvRenderGrid from "./fvRenderGrid"
import fvRenderLine from "./fvRenderLine"
import fvRenderMove from "./fvRenderMove"
import fvRenderPath from "./fvRenderPath"
import fvRenderScript from "./fvRenderScript"
import fvRenderTexture from "./fvRenderTexture"

Vue.prototype.fvRender = fvRender;
Vue.prototype.fvRenderContract = fvRenderContract;
Vue.prototype.fvRenderGrid = fvRenderGrid;
Vue.prototype.fvRenderLine = fvRenderLine;
Vue.prototype.fvRenderMove = fvRenderMove;
Vue.prototype.fvRenderPath = fvRenderPath;
Vue.prototype.fvRenderScript = fvRenderScript;
Vue.prototype.fvRenderTexture = fvRenderTexture;


// WEBPACK FOOTER //
// ./src/js/render/index.js